import { AgentAvailabilityState } from '@bd/agent/types'

export const isAvailabilitySet = (
  state: AgentAvailabilityState | undefined,
) => {
  return !!(state?.availabilityRules && state.availabilityRules.length)
}
